import { create } from 'zustand';
import Cookies from 'js-cookie';
import axios from 'axios';

const useAuthStore = create((set, get) => ({
    isAuth: null,
    accessToken: '',
    refreshAccessTokenValue: '',
    userName: '',
    userEmail: '',
    userPhone: '',
    stayLoggedIn: false,
    refreshInProgress: false,

    login: (data, stayLoggedIn) => {
        set({
            isAuth: true,
            accessToken: data.access_token,
            refreshAccessTokenValue: data.refresh_token,
            userName: data.user.name,
            userEmail: data.user.email,
            userPhone: data.user.phone,
            stayLoggedIn: stayLoggedIn,
        });

        Cookies.set('access_token', data.access_token, { expires: 7 });
        Cookies.set('refresh_token', data.refresh_token, { expires: 7 });
        Cookies.set('username', data.user.name, { expires: 7 });
        Cookies.set('useremail', data.user.email, { expires: 7 });
        Cookies.set('userphone', data.user.phone, { expires: 7 });
        Cookies.set('stayLoggedIn', stayLoggedIn, { expires: 365 });
    },

    logout: () => {
        Cookies.remove('access_token');
        Cookies.remove('refresh_token');
        Cookies.remove('username');
        Cookies.remove('useremail');
        Cookies.remove('userphone');
        Cookies.remove('stayLoggedIn');

        set({
            isAuth: false,
            accessToken: '',
            refreshAccessTokenValue: '',
            userName: '',
            userEmail: '',
            userPhone: '',
            stayLoggedIn: false,
            refreshInProgress: false,
        });
    },

    refreshAccessToken: async () => {
        const refreshAccessToken = Cookies.get('refresh_token');
        const stayLoggedIn = Cookies.get('stayLoggedIn');
        const apiUrl = (process.env.NEXT_PUBLIC_API_URL || '').replace(/\/$/, '');

        if (stayLoggedIn === 'false') {
            console.warn('Stay logged in is false, not refreshing token');
            return;
        }

        if (!refreshAccessToken) {
            console.warn('No refresh token found');
            return;
        }

        set({ refreshInProgress: true });

        try {
            const response = await axios.post(`${apiUrl}/api/auth/refresh/`, { refresh_token: refreshAccessToken });
            if (response.status === 200) {
                set({
                    accessToken: response.data.access_token,
                    refreshAccessTokenValue: response.data.refresh_token,
                });

                // Update cookies with new tokens
                Cookies.set('access_token', response.data.access_token, { expires: 7 });
                Cookies.set('refresh_token', response.data.refresh_token, { expires: 7 });
            } else {
                console.error('Failed to refresh token:', response.status, response.data);
                get().logout();
            }
        } catch (error) {
            console.error('Error refreshing token:', error);
            get().logout();
        } finally {
            set({ refreshInProgress: false });
        }
    },

    hydrate: (data = {}) => {
        const isAuth = !!Cookies.get('access_token');
        const stayLoggedIn = Cookies.get('stayLoggedIn') === 'true';

        set({
            isAuth: isAuth,
            accessToken: Cookies.get('access_token') || '',
            refreshAccessTokenValue: Cookies.get('refresh_token') || '',
            userName: Cookies.get('username') || '',
            userEmail: Cookies.get('useremail') || '',
            userPhone: Cookies.get('userphone') || '',
            stayLoggedIn: stayLoggedIn,
            ...data,
        });
    },
}));

export default useAuthStore;
